module.exports = __webpack_public_path__ + "static/media/features5.4cd607b6.jpg";